<template>
  <div>
    <template v-if="$store.getters.currentRoomType">
      <template v-if="$store.getters.currentRoomType.DISPLAY?.ROOM_NON_SMOKING">
        <a v-if="false !== isRoomTypeVariantExists('ROOM_SMOKING', true, 0)"
           title="Click to See Smoking Room Options" href="#"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])">No</a>
        <template v-else>
          No
        </template>
      </template>
      <template v-else-if="$store.getters.currentRoomType.DISPLAY?.ROOM_SMOKING">
        <a v-if="false !== isRoomTypeVariantExists('ROOM_NON_SMOKING', true, 0)"
           title="Click to See Smoking Room Options" href="#"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])">Yes</a>
      </template>
      <template v-else>
        Yes
      </template>
    </template>
    <a v-else data-tooltip="Click to See Smoking Room Options" href="#"
       @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])">No</a>
    <template v-else>
      No
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "quick-details-smoking",
  methods: {
    isRoomTypeVariantExists(dataKey: string, dataValue: boolean, omitPrtId = 0, valueModifierFunction = (val: string) => val) {
      for (let i = 0, l = this.$store.state.roomData.length; i < l; i++) {
        if (this.$store.state.roomData[i].PRT_ID !== omitPrtId && this.$store.state.roomData[i].DISPLAY && dataKey in this.$store.state.roomData[i].DISPLAY && dataValue === valueModifierFunction(this.$store.state.roomData[i].DISPLAY[dataKey])) {
          return parseInt(this.$store.state.roomData[i].PRT_ID, 10);
        }
      }
      return false;
    }
  }
})
</script>

<style scoped>

</style>